import { render, staticRenderFns } from "./powerbank.vue?vue&type=template&id=4b5ad38e&scoped=true&"
import script from "./powerbank.vue?vue&type=script&lang=js&"
export * from "./powerbank.vue?vue&type=script&lang=js&"
import style0 from "./powerbank.vue?vue&type=style&index=0&id=4b5ad38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ad38e",
  null
  
)

export default component.exports